import React from 'react';
import { Link } from '@shopify/polaris';
import { Text } from '@shopify/polaris';

const Footer = () => {
  return (
    <div style={{ 
      borderTop: '1px solid #dfe3e8', 
      padding: '20px 0', 
      marginTop: '40px',
      textAlign: 'center',
      backgroundColor: '#ffffff',
      width: '100%',
      position: 'relative',
      zIndex: 5
    }}>
      <div style={{ marginBottom: '10px' }}>
        <Link url="/privacy-policy" monochrome>Privacy Policy</Link>
        <span style={{ margin: '0 10px' }}>•</span>
        <Link url="/terms-of-service" monochrome>Terms of Service</Link>
        <span style={{ margin: '0 10px' }}>•</span>
        <Link url="/contact-us" monochrome>Contact Us</Link>
      </div>
      <Text variant="bodySm" color="subdued">
        Copyright &copy; {new Date().getFullYear()} Elevia Solutions. All rights reserved.
      </Text>
    </div>
  );
};

export default Footer;
